export default remote => ({
    all: (params) => remote.get(`countries`, { params: params })
});
